import { jsx as _jsx } from "react/jsx-runtime";
import { Root, Skeleton } from "./AppSwitcher.components.js";
import AppSwitcherMenuMain from "./components/Main.js";
import AppSwitcherMenuHeader from "./components/Header.js";
import AppSwitcherMenuFooter from "./components/Footer.js";
export const AppSwitcherMenuMoleculeComponent = ({ header, data, slotProps, isLoading, hideHeader, ...props }) => {
    const slots = {
        ...(!hideHeader && {
            header: AppSwitcherMenuHeader,
        }),
        footer: AppSwitcherMenuFooter,
    };
    const renderLoading = isLoading && !data?.length;
    return (_jsx(Root, { slots: slots, slotProps: { header, root: slotProps?.paper }, ...props, children: renderLoading ? (_jsx(Skeleton, { "data-testid": "AppSwitcherMenuLoader", variant: "rounded", animation: "wave", gap: 2, ...slotProps?.loader })) : (_jsx(AppSwitcherMenuMain, { data: data, isLoading: isLoading })) }));
};
export default AppSwitcherMenuMoleculeComponent;
